module.exports = __webpack_public_path__ + "img/team-rob@2x.ec0bc4c2.jpg";